import { FC } from 'react';
// component
import CommonSweetenerAndFlavorRadioGroup from 'components/common/CommonSweetenerAndFlavorRadioGroup';

const Chewable: FC = () => <CommonSweetenerAndFlavorRadioGroup />;

export default Chewable;
